import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'vant/lib/index.css';
import { Dialog, Toast } from 'vant';

// 动态设置根字体大小
// (function(doc, win) {
//   var docEl = doc.documentElement,
//     recalc = function() {
//       var clientWidth = docEl.clientWidth;
//       if (!clientWidth) {
//         console.warn('无法获取视口宽度');
//         return;
//       }
//       docEl.style.fontSize = clientWidth / 7.5 + 'px';
//     };

//   if (!doc.addEventListener){ 
//     console.warn('不支持 addEventListener');
//     return;
//   }

//   doc.addEventListener('DOMContentLoaded', recalc, false);
//   win.addEventListener('resize', recalc, false);
// })(document, window);

Vue.config.productionTip = false;

Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')